export const MAX_FETCH_GOAL_TRIALS = 3